const assignments = new Map();
let lastGame = 'snake';

// Rotate the featured choice for new generations without reshuffling a card
// on rerender. Users can always choose another game. Bound the session cache.
export function getWaitingGame(generationKey, desktop = false) {
  if (assignments.has(generationKey)) {
    const assigned = assignments.get(generationKey);
    return assigned === 'snake' && !desktop ? 'flappy' : assigned;
  }
  const games = desktop ? ['balloon', 'flappy', 'snake'] : ['balloon', 'flappy'];
  const game = games[(games.indexOf(lastGame) + 1) % games.length];
  lastGame = game;
  assignments.set(generationKey, game);
  if (assignments.size > 200) assignments.delete(assignments.keys().next().value);
  return game;
}
